//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const ShowSubmitSuccessIssuesWarning: FeatureFlag = {"Id":"ShowSubmitSuccessIssuesWarning","Label":"[10.20]Show submit success issues warning","Impact":"Shows warning in submit success dialog when active issues exist. Most relevant when ForceValidIfPaymentValid and/or IgnorePaymentAmountMismatch create payment-related issues that continue to reviewer follow-up.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
